module.exports = __webpack_public_path__ + "media/customizations/chathampark/back-63c8774ab544942e1713a53788b7631f.jpg";